import { render, staticRenderFns } from "./PasswordTestSimple.vue?vue&type=template&id=1c1c75d7&scoped=true&"
import script from "./PasswordTestSimple.vue?vue&type=script&lang=js&"
export * from "./PasswordTestSimple.vue?vue&type=script&lang=js&"
import style0 from "./PasswordTestSimple.vue?vue&type=style&index=0&id=1c1c75d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1c75d7",
  null
  
)

export default component.exports